import {style} from 'typestyle'

export const CategorySwiper = style({
    // paddingTop: 57,
    paddingBottom: 20
})

export const selectMenu = style({
    display: 'block',
    // position: 'fixed',
    // bottom: 50,
    zIndex: 150,
    width: '100%',
    height: 44,
    paddingTop: 6,
    maxWidth: 480,
    background: '#fff',
    top: 0
    // boxShadow: '0 2px 8px 0 #F0F0F0'
})



// WEBPACK FOOTER //
// ./src/views/Category/Category.style.ts